import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import Error from '../../Visuals/Images/Error.svg';
import { ErrorBoundaryContainer, ErrorWords } from './ErrorBoundary.styles';
import PrimaryButtonComponent from '../../Components/Buttons/PrimaryButton/PrimaryButton.component';

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (error.message.includes('token expired')) {
      navigate('/login');
    }
  }, [error, navigate]);
  return (
    <ErrorBoundaryContainer>
      <div>
        <img src={Error} alt="Error" />
        <ErrorWords>
          <h3>Sorry, something went wrong:</h3>
          <span>{error.message}</span>
          <PrimaryButtonComponent
            span="Try Again"
            functionName={resetErrorBoundary}
          />
        </ErrorWords>
      </div>
    </ErrorBoundaryContainer>
  );
};

const ErrorBoundary = ({ children }) => {
  const navigate = useNavigate();
  return (
    <ReactErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        navigate('/');
      }}
    >
      {children}
    </ReactErrorBoundary>
  );
};

ErrorFallback.propTypes = {
  error: PropTypes.object,
  resetErrorBoundary: PropTypes.func,
};

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};

export default ErrorBoundary;
